/* ============================================================================
FILE: po-katupirsia5-mopo-texts-fr-en-es-20260303.js
MODE: TRILINGUE (FR/EN/ES) + lexicon injection (if present)
API:  window.PoKatupirsia5MOPoTextsFR_EN_ES_20260303
ROOT: .po-axis-section[data-po-axis]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (navigateur ou storage).
  - Protection fine: verrouille (translate="no") TOUTES les occurrences du lexique simplifié (si disponible),
    avec variantes apostrophes + œ/oe, et anti-collage (espaces DOM/HTML uniquement quand nécessaire).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Compat: conserve un alias API window.GoodyTwinLang (getLang/setLang/init) pour éviter de casser d’anciens appels.
  - Ajoute une couche audio générale + audio locale par bloc, sans casser le socle existant.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_MOPO_TEXTS_20260303__) return;
  window.__PO_K5_MOPO_TEXTS_20260303__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';
  var TARGET_ID = 'mopo';

  var IMG_IDEOGRAM_CONCEPT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mathesis_onthologique_posoennoial_2_copie.png?v=1772887173';
  var IMG_ELEMENT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535';
  var IMG_TOTEM = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195';
  var IMG_FREQ_379 = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/nombre_guide_379.png?v=1773410504';

  var CANON = {
    title: 'Mathêsis ontologique posœnnoïale (MOPo)',
    page_terms: [
      'Mathêsis ontologique posœnnoïale (MOPo)',
      'Mathêsis ontologique posœnnoïale',
      'MOPo',
      'Katûpirsia',
      'Katûpirsia 5',
      'La Matrice-substrat',
      'Katûsýs',
      'La Katûvýs',
      'Katûvýs',
      'Êkhö',
      'RéZonans',
      'Posœnnoïa',
      'Posœnnomia',
      'Posœnnoïamie',
      'Katûvýsissence',
      'Lulæṣírasen',
      'Tiqqunbahu',
      'Takimarah',
      'Extratinrieur',
      'Ušôprogalenmestûd',
      'Modalités opératives',
      'Piliers',
      'Outils',
      'Engrenages',
      'synchrêtique',
      'extratinrioral',
      'nombre-guide'
    ]
  };

  function clampStr(v){ return (v == null) ? '' : String(v); }

  function normLang(raw){
    var v = clampStr(raw).toLowerCase().trim().replace(/_/g, '-');
    if (v.indexOf('fr') === 0) return 'fr';
    if (v.indexOf('en') === 0) return 'en';
    if (v.indexOf('es') === 0) return 'es';
    if (v.indexOf('pt') === 0) return 'es';
    return '';
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return '';
  }

  var __PO_HTML_LANG_SYNC__ = false;

  function storeLang(lang){
    var v = normLang(lang) || 'fr';
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{
      if (document && document.documentElement){
        var currentLang = normLang(document.documentElement.getAttribute('lang') || '') || '';
        if (currentLang !== v){
          __PO_HTML_LANG_SYNC__ = true;
          document.documentElement.setAttribute('lang', v);
          setTimeout(function(){ __PO_HTML_LANG_SYNC__ = false; }, 0);
        }
      }
    }catch(e){ __PO_HTML_LANG_SYNC__ = false; }
    return v;
  }

  function detectBrowserLang(){
    try{
      var dl = (document && document.documentElement) ? (document.documentElement.getAttribute('lang') || '') : '';
      var dln = normLang(dl);
      if (dln) return dln;
    }catch(e){}
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return 'fr';
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || 'fr';
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event('po:locale-changed'));
    }catch(e){
      try{
        var ev = document.createEvent('Event');
        ev.initEvent('po:locale-changed', true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getTargetBlocks(){
    var nodes = [];
    try{
      var all = document.querySelectorAll(ROOT_SEL);
      for (var i=0;i<all.length;i++){
        var id = '';
        try{ id = all[i].getAttribute('data-po-lex-id') || ''; }catch(e){ id = ''; }
        if (id === TARGET_ID) nodes.push(all[i]);
      }
    }catch(e){}
    return nodes;
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return '';
    try{ if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]); }catch(e){}
    return '';
  }

  function pickDefShort(entry, lang){
    if (!entry) return '';
    var ks = 'definition_short_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return '';
  }

  function pickDefLong(entry, lang){
    if (!entry) return '';
    var kl = 'definition_long_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return '';
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + '_' + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{ if (entry && entry[key] != null) return entry[key]; }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION FINE
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/\"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function uniqPush(arr, v, seen){
    var k = clampStr(v);
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, '’'), seen);
    uniqPush(out, t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE'), seen);
    uniqPush(out, t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ'), seen);

    var oe1 = t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE');
    var oe2 = t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ');
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, '’'), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, '’'), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    var out = [];
    var seen = Object.create(null);

    function addMany(arr){
      if (!Array.isArray(arr)) return;
      for (var i=0;i<arr.length;i++) uniqPush(out, arr[i], seen);
    }

    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON_META.lexique_simplifie_fr);
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON.meta.lexique_simplifie_fr);
      }
    }catch(e){}
    addMany(CANON.page_terms);
    return out;
  }

  var __PO_PROTECT_CACHE__ = { key:'', re:null };

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    var seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var list = buildVariants(base[i]);
      for (var j=0;j<list.length;j++) uniqPush(variants, list[j], seen);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) parts.push(escapeRegExp(variants[k]));
    if (!parts.length) return null;
    try{ return new RegExp('(' + parts.join('|') + ')', 'g'); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = 'meta:none';
    try{ var l = getSimplifiedLexiqueFRList(); key = 'meta:' + (l ? l.length : 0); }catch(e){ key = 'meta:none'; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectMatcher();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute('translate');
    if (tr && String(tr).toLowerCase() === 'no') return true;
    var cls = el.className || '';
    if (typeof cls === 'string'){
      if (cls.indexOf('notranslate') !== -1) return true;
      if (cls.indexOf('po-lex-protect') !== -1) return true;
      if (cls.indexOf('po-axis-audio-wrap') !== -1) return true;
      if (cls.indexOf('po-axis-audio-btn') !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch || '');
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var hit = m[0];
      var end = start + hit.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : '';
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(' '));

      var span = doc.createElement('span');
      span.setAttribute('translate', 'no');
      span.className = 'po-lex-protect notranslate';
      span.textContent = hit;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : '';
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(' '));

      last = end;
      if (hit.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : '';
            if (pn === 'SCRIPT' || pn === 'STYLE') return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    var s = clampStr(html);
    if (!s) return '';
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return s;

    var tpl = document.createElement('template');
    tpl.innerHTML = s;
    var root = tpl.content || tpl;
    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return s; }
    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return '';
    return '<p>' + escapeHTML(s).replace(/\n+/g, '</p><p>') + '</p>';
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: '',
    speaking: false,
    utterance: null
  };

  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){
    var L = normLang(lang) || 'fr';
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles-mopo-20260303')) return;
    var st = document.createElement('style');
    st.id = 'po-axis-audio-styles-mopo-20260303';
    st.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}',
      '.po-axis-audio-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid rgba(184,134,11,.45);border-radius:999px;padding:8px 12px;background:rgba(0,0,0,.02);font:inherit;font-weight:800;letter-spacing:.2px;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;box-shadow:0 0 0 1px rgba(184,134,11,.12),0 8px 18px rgba(31,122,58,.10);}',
      '.po-axis-audio-btn:hover{box-shadow:0 0 0 1px rgba(184,134,11,.24),0 10px 24px rgba(31,122,58,.14);}',
      '.po-axis-audio-btn.is-active{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.20),0 12px 28px rgba(31,122,58,.18);}',
      '.po-axis-audio-btn__label{color:var(--color-accent,#1f7a3a);}',
      '.po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;padding:6px 10px;font-size:12px;}',
      '.po-lex-summary .po-axis-audio-btn__label{white-space:nowrap;}',
      '@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{order:3;width:100%;justify-content:center;margin-top:8px;}}'
    ].join('');
    document.head.appendChild(st);
  }

  function createAudioButton(role, index){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (index != null) btn.setAttribute('data-po-audio-index', String(index));
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<span class="po-axis-audio-btn__label"></span>';
    return btn;
  }

  function getAudioButtonLabel(role, lang, isActive){
    var ui = audioUI(lang);
    if (isActive) return ui.stop;
    return role === 'general' ? ui.general : ui.block;
  }

  function updateAudioButtonLabel(btn, lang, isActive){
    if (!btn) return;
    var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
    var label = btn.querySelector('.po-axis-audio-btn__label') || btn;
    label.textContent = getAudioButtonLabel(role, lang, !!isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    if (isActive) btn.classList.add('is-active'); else btn.classList.remove('is-active');
  }

  function updateAudioButtonsState(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role]');
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : '';
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      updateAudioButtonLabel(btn, lang, key && key === activeKey && PO_AUDIO_STATE.speaking);
    }
  }

  function stopAudio(resetButtons){
    try{ if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.speaking = false;
    PO_AUDIO_STATE.utterance = null;
    if (resetButtons !== false){
      var roots = getTargetBlocks();
      for (var i=0;i<roots.length;i++) updateAudioButtonsState(roots[i], getLang());
    }
  }

  function cleanAudioText(s){
    return clampStr(s).replace(/\s+/g, ' ').replace(/[•·]+/g, '. ').replace(/\s([;:!?])/g, '$1').trim();
  }

  function collectTextFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    try{
      var kill = clone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style, [aria-hidden="true"]');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    return cleanAudioText(clone.textContent || '');
  }

  function buildGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = collectTextFromNode(el);
      if (txt) parts.push(txt);
    }
    return cleanAudioText(parts.join('. '));
  }

  function buildDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleTxt = collectTextFromNode(title);
    if (titleTxt) parts.push(titleTxt);

    var bodyClone = detail.cloneNode(true);
    try{
      var summary = bodyClone.querySelector('summary');
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      var kill = bodyClone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    var bodyTxt = cleanAudioText(bodyClone.textContent || '');
    if (bodyTxt) parts.push(bodyTxt);
    return cleanAudioText(parts.join('. '));
  }

  function splitTextForSpeech(text, limit){
    var maxLen = limit || 220;
    var raw = cleanAudioText(text);
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:…]+[.!?;:…]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i=0;i<pieces.length;i++){
      var piece = cleanAudioText(pieces[i]);
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > maxLen){
        if (current) out.push(current.trim());
        if (piece.length > maxLen){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + ' ' + w) : w;
            if (next.length > maxLen){
              if (acc) out.push(acc.trim());
              acc = w;
            } else acc = next;
          }
          current = acc || '';
        } else current = piece;
      } else current = current ? (current + ' ' + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function pickSpeechVoice(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var code = normLang(lang || getLang()) || 'fr';
    var prefixes = code === 'fr' ? ['fr','fr-'] : (code === 'es' ? ['es','es-'] : ['en','en-']);
    for (var i=0;i<voices.length;i++){
      var vLang = clampStr(voices[i].lang).toLowerCase();
      if (!vLang) continue;
      for (var j=0;j<prefixes.length;j++) if (vLang === prefixes[j] || vLang.indexOf(prefixes[j]) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function buildAudioUnits(root, startKey){
    var units = [];
    if (!root) return units;
    var details = root.querySelectorAll('.po-lex-details');
    var startAt = 0;
    var useGeneral = (startKey === 'general');
    if (useGeneral){
      var generalTxt = buildGeneralText(root);
      if (generalTxt) units.push({ key:'general', kind:'general', text:generalTxt, detail:null });
      startAt = 0;
    } else {
      var parsed = parseInt(String(startKey || '').replace(/^block-/, ''), 10);
      startAt = isNaN(parsed) ? 0 : parsed;
    }
    for (var i=startAt;i<details.length;i++){
      var txt = buildDetailText(details[i]);
      if (txt) units.push({ key:'block-' + i, kind:'block', text:txt, detail:details[i] });
    }
    return units;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.kind !== 'block' || !unit.detail) return;
    try{ unit.detail.open = true; }catch(e){}
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.speaking) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio(true);
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text, 220);
      PO_AUDIO_STATE.chunkPos = -1;
      openDetailIfNeeded(unit);
      if (PO_AUDIO_STATE.root) updateAudioButtonsState(PO_AUDIO_STATE.root, getLang());
      if (!PO_AUDIO_STATE.chunks.length){ speakNextChunk(); return; }
      speakNextChunk();
      return;
    }
    var chunk = clampStr(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    if (!chunk){ speakNextChunk(); return; }
    var utt;
    try{ utt = new SpeechSynthesisUtterance(chunk); }catch(e){ stopAudio(true); return; }
    var lang = getLang();
    utt.lang = lang === 'fr' ? 'fr-FR' : (lang === 'es' ? 'es-ES' : 'en-US');
    var voice = pickSpeechVoice(lang);
    if (voice) utt.voice = voice;
    utt.rate = 0.96;
    utt.pitch = 1;
    utt.volume = 1;
    utt.onend = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    utt.onerror = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    PO_AUDIO_STATE.utterance = utt;
    try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(true); }
  }

  function startAudio(root, startKey){
    if (!PO_AUDIO_SYNTH || !root) return;
    var sameRoot = (PO_AUDIO_STATE.root === root);
    var sameKey = (PO_AUDIO_STATE.activeKey === startKey);
    if (sameRoot && sameKey && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
      stopAudio(true);
      return;
    }
    stopAudio(false);
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildAudioUnits(root, startKey);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = startKey;
    PO_AUDIO_STATE.speaking = true;
    updateAudioButtonsState(root, getLang());
    speakNextChunk();
  }

  function bindAudioButton(btn, root){
    if (!btn || !root || btn.__poAudioBound) return;
    btn.addEventListener('click', function(ev){
      if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      if (ev && typeof ev.stopPropagation === 'function') ev.stopPropagation();
      if (!PO_AUDIO_SYNTH) return;
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      startAudio(root, key);
    });
    btn.__poAudioBound = true;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (!panel) return;

    var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
    if (!generalWrap){
      generalWrap = document.createElement('div');
      generalWrap.className = 'po-axis-audio-wrap';
      generalWrap.setAttribute('data-po-audio-role', 'general');
      var generalBtn = createAudioButton('general');
      generalWrap.appendChild(generalBtn);
      var meta = root.querySelector('.po-axis-meta');
      var defShort = root.querySelector('[data-po-slot="def_short"]');
      var firstDetail = panel.querySelector('.po-lex-details');
      if (meta && meta.parentNode){
        if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
      } else if (defShort && defShort.parentNode){
        defShort.parentNode.insertBefore(generalWrap, defShort);
      } else if (firstDetail && firstDetail.parentNode){
        firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
      } else panel.appendChild(generalWrap);
    }

    var generalButton = generalWrap.querySelector('.po-axis-audio-btn[data-po-audio-role="general"]');
    if (!generalButton){
      generalButton = createAudioButton('general');
      generalWrap.appendChild(generalButton);
    }
    bindAudioButton(generalButton, root);

    var details = root.querySelectorAll('.po-lex-details');
    for (var i=0;i<details.length;i++){
      details[i].setAttribute('data-po-audio-index', String(i));
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton('block', i);
        summary.appendChild(btn);
      } else btn.setAttribute('data-po-audio-index', String(i));
      bindAudioButton(btn, root);
    }

    updateAudioButtonsState(root, lang || getLang());
  }

  function initAudioEverywhere(lang){
    var l = normLang(lang || getLang()) || 'fr';
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) ensureAudioButtons(roots[i], l);
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.getVoices === 'function'){
      PO_AUDIO_SYNTH.onvoiceschanged = function(){
        try{ initAudioEverywhere(getLang()); }catch(e){}
      };
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACKS MOPo
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: CANON.title,
    kicker: 'Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs : organe interne de La Katûvýs)',
    cta_translate: 'Proposer une traduction du concept',
    h_def: 'Définition opérative',
    chips: ['Élément', 'Totem', 'Fréquence'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_379],
    def_short: 'Propagation transductive du sens.',
    def_long:
      'La genèse d’une matrice de reliance.\n\n' +
      'La Mathêsis ontologique posœnnoïale, la MOPo, se déploie comme une architecture vivante de structuration de l’être, fondée sur une dynamique vibratoire, sensible, relationnelle et symboliquement informée. Elle fait apparaître, à travers les flux du réel, les trames vibratoires qui relient formes, intentions, perceptions, langages et vécus dans une RéZonans signifiante et transmutative. Cette architecture privilégie l’émergence et la lisibilité des relations, et révèle les cohérences en mouvement qui traversent les plans de l’expérience.\n\n' +
      'La Mathêsis s’actualise dans un processus extratinrioral, espace d’échange où intériorité et extériorité entrent en résonance et composent des zones de passage. L’être s’y transforme en transformant ce qu’il perçoit, et la connaissance s’y forme par circulation, ajustement et reprise. Inscrite dans une logique synchrêtique, la MOPo opère par addition dynamique de savoirs, de formes, de traditions et de fréquences, mises en co-présence féconde. La Posœnnoïa en constitue la source pulsative : principe d’orientation et de questionnement, elle active les opérations de liaison et de modulation, et soutient l’ouverture continue des parcours.\n\n' +
      'La Mathêsis posœnnoïale repose sur une transduction ontologique où penser, créer, comprendre et transmettre s’accordent comme modalités vibrantes d’un même acte énergétique. Cet acte se module selon les milieux, les corps, les intentions et les intensités du réel. Il s’incarne dans les Piliers, les Outils et les Engrenages, mis en jeu par les Modalités opératives, et s’éprouve au sein de topologies telles que la Posœnnomia et de pratiques comme la Posœnnoïamie, selon des fréquences ajustées.\n\n' +
      'Cette Mathêsis agit par oscillation, passage et spiralisation. Elle propose une ontologie de l’être comme relation modulée, où les formes se définissent par leur capacité à entrer en RéZonans avec des champs de perception en expansion. Les configurations y gagnent en plasticité rythmique et en intelligibilité relationnelle, et l’être s’y comprend comme processus d’accords successifs.\n\n' +
      'Elle est Mathêsis parce qu’elle structure les conditions de lisibilité et d’apprentissage du réel ; ontologique parce qu’elle engage la nature même de ce réel ; posœnnoïale parce qu’elle s’éprouve dans un système traversé par le souci du lien, du rythme et du seuil, où chaque opération participe d’une intelligence vibratoire en mouvement.',
    h_features: 'Déploiement',
    h_questions: 'Tests d’usage',
    hint_fold: 'déplier',
    example_title: 'Exemple opératif',
    example: '1) Quand des lignes de sens se croisent et demandent tenue : « la MOPo ancre ». 2) Quand un sens circule entre idée, perçu, dit, transmis : « la MOPo propage ». 3) Quand une singularité doit s’accorder au champ sans perdre sa signature : « j’active la MOPo ».',
    features: [
      'La MOPo se formule comme « genèse d’une matrice de reliance » : elle rend la circulation transductive du sens praticable, accorde les singularités, et organise l’acte de percevoir, penser, créer et transmettre en un même régime énergétique.',
      'Architecture vivante de structuration de l’être par RéZonans : formes, intentions, perceptions, langages et vécus s’y composent en champ actif.',
      'Processus extratinrioral : espace de passage où intériorité et extériorité entrent en résonance et composent des zones d’échange.',
      'Logique synchrêtique : addition dynamique de savoirs, de formes, de traditions et de fréquences, accordées en co-présence féconde.',
      'Fonction principale : propagation transductive du sens ; soutien vibratoire pour les lignes de sens croisées ; ancrage pour l’ajustement du sens entre l’idée, le perçu, le dit et le transmis.'
    ],
    questions: [
      'Quand des lignes de sens se croisent et demandent tenue : « la MOPo ancre ».',
      'Quand un sens circule entre idée, perçu, dit, transmis : « la MOPo propage ».',
      'Quand une singularité doit s’accorder au champ sans perdre sa signature : « j’active la MOPo ».',
      'Quand il faut harmoniser les singularités dans un champ vivant de perception, création et transmission : « la MOPo relie ».'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Position systémique :</strong> la MOPo appartient à <strong>Katûsýs</strong>, au cœur de la bande interne de fréquences potentielles issue de <strong>La Katûvýs</strong>. Elle s’incarne dans les <strong>Piliers</strong>, les <strong>Outils</strong> et les <strong>Engrenages</strong>, s’active par les <strong>Modalités opératives</strong>, et s’éprouve dans des topologies et pratiques comme <strong>Posœnnomia</strong> et <strong>Posœnnoïamie</strong>.</p>',
    family_2: '<p><strong>Relations prioritaires :</strong> la MOPo se lit en syntonie avec <strong>Lulæṣírasen</strong>, <strong>Tiqqunbahu</strong>, <strong>Takimarah</strong>, <strong>Extratinrieur</strong>, <strong>Katûvýsissence</strong> et <strong>Ušôprogalenmestûd</strong>. Elle agit comme structure transductive de propagation du sens dans l’ensemble de <strong>Katûsýs</strong>.</p>',
    h_wordbuild: 'Construction du nom & fréquence 379',
    word_blocks: [
      { head: 'Mathêsis', text: 'Structure les conditions de lisibilité et d’apprentissage du réel ; puissance de structuration du sens.' },
      { head: 'Ontologique', text: 'Engage la nature même du réel : être, relation, seuil, circulation, modulation.' },
      { head: 'Posœnnoïale', text: 'Qualifie le mode d’expérience et d’activation propre au système : RéZonans, passage, rythme, intelligence vibratoire.' },
      { head: 'Sigle canonisé', text: 'MOPo est un sigle canonisé : un signe bref pour un organe de structuration vive, immédiatement mobilisable dans la conduite des pratiques.' },
      { head: 'Fréquence 379', text: '379 agit comme fréquence-seuil de structuration dynamique : 3 relie, 7 ouvre un passage intérieur, 9 prolonge vers la transmission et l’expansion spiralée. La réduction 3 + 7 + 9 = 19 → 10 → 1 signale le retour spiralé à la Posœnnoïa.' }
    ],
    word_notes: [
      'Élément : La Katûvýs ; Totem : Êkhö ; Fréquence (nombre-guide) : 379.',
      'Ossature transductive du sens ; matrice de reliance.',
      'La MOPo organise les interactions entre perception, langage, création et intention afin de rendre intelligible la dynamique du réel.'
    ]
  };

  var FALLBACK_EN = {
    title: CANON.title,
    kicker: 'Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: internal organ of La Katûvýs)',
    cta_translate: 'Suggest a translation of the concept',
    h_def: 'Operative definition',
    chips: ['Element', 'Totem', 'Frequency'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_379],
    def_short: 'Propagation transductive du sens.',
    def_long:
      'La genèse d’une matrice de reliance.\n\n' +
      'The ' + CANON.title + ' unfolds as a living architecture of structuring being, grounded in a vibratory, sensitive, relational and symbolically informed dynamic. It makes visible, through the flows of the real, the vibratory threads that link forms, intentions, perceptions, languages and lived experiences in a meaningful, transmutative RéZonans.\n\n' +
      'This Mathêsis becomes actual in an extratinrioral process, a zone of exchange where interiority and exteriority resonate and compose passages. Knowledge forms there through circulation, adjustment and reprise. Within a synchrêtique logic, the MOPo operates by dynamic addition of knowledges, forms, traditions and frequencies set into fertile co-presence. Posœnnoïa acts as its pulsative source.\n\n' +
      'The MOPo establishes a transductive articulation between idea, perceived, said and transmitted. It structures the conditions of readability and learning, engages the nature of the real, and unfolds within a system traversed by link, rhythm and threshold.',
    h_features: 'Unfolding',
    h_questions: 'Use tests',
    hint_fold: 'expand',
    example_title: 'Operative example',
    example: '1) When lines of meaning cross and require hold: “MOPo anchors.” 2) When meaning circulates between idea, perceived, said and transmitted: “MOPo propagates.” 3) When a singularity must tune to the field without losing its signature: “I activate the MOPo.”',
    features: [
      '“Genèse d’une matrice de reliance”: the MOPo makes the transductive circulation of meaning practicable and accords singularities without dissolving them.',
      'Living architecture of structuring being through RéZonans: forms, intentions, perceptions, languages and lived experience compose an active field.',
      'Extratinrioral process: a passage-space where interiority and exteriority resonate and form zones of exchange.',
      'Synchrêtique logic: dynamic addition of knowledges, forms, traditions and frequencies in fertile co-presence.',
      'Main function: propagation transductive du sens; vibratory support for crossed lines of meaning; anchoring for the tuning of meaning.'
    ],
    questions: [
      'When lines of meaning cross and require hold: “MOPo anchors.”',
      'When meaning circulates between idea, perceived, said and transmitted: “MOPo propagates.”',
      'When a singularity must tune to the field without losing its signature: “I activate the MOPo.”',
      'When singularities must be harmonized in a living field of perception, creation and transmission: “MOPo relates.”'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Systemic position:</strong> the MOPo belongs to <strong>Katûsýs</strong>, at the heart of the inner band of potential frequencies issued from <strong>La Katûvýs</strong>. It takes body in the <strong>Piliers</strong>, <strong>Outils</strong> and <strong>Engrenages</strong>, is activated through the <strong>Modalités opératives</strong>, and is experienced in topologies and practices such as <strong>Posœnnomia</strong> and <strong>Posœnnoïamie</strong>.</p>',
    family_2: '<p><strong>Priority relations:</strong> the MOPo stands in syntony with <strong>Lulæṣírasen</strong>, <strong>Tiqqunbahu</strong>, <strong>Takimarah</strong>, <strong>Extratinrieur</strong>, <strong>Katûvýsissence</strong> and <strong>Ušôprogalenmestûd</strong>. It acts as the transductive structure of propagation of meaning across <strong>Katûsýs</strong>.</p>',
    h_wordbuild: 'Name formation & frequency 379',
    word_blocks: [
      { head: 'Mathêsis', text: 'Structures the conditions of readability and learning of the real; a power of structuring meaning.' },
      { head: 'Ontologique', text: 'Engages the very nature of the real: being, relation, threshold, circulation, modulation.' },
      { head: 'Posœnnoïale', text: 'Qualifies the mode of experience and activation proper to the system: RéZonans, passage, rhythm, vibratory intelligence.' },
      { head: 'Canonical acronym', text: 'MOPo is a canonized acronym: a brief sign for a living organ of structuring, immediately usable in practice.' },
      { head: 'Frequency 379', text: '379 acts as a threshold-frequency of dynamic structuring: 3 links, 7 opens an inner passage, 9 prolongs toward transmission and spiral expansion. The reduction 3 + 7 + 9 = 19 → 10 → 1 signals the spiral return to Posœnnoïa.' }
    ],
    word_notes: [
      'Élément: La Katûvýs; Totem: Êkhö; Frequency (nombre-guide): 379.',
      'Ossature transductive du sens; matrice de reliance.',
      'The MOPo organizes the interactions between perception, language, creation and intention so the dynamic of the real becomes readable.'
    ]
  };

  var FALLBACK_ES = {
    title: CANON.title,
    kicker: 'Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: órgano interno de La Katûvýs)',
    cta_translate: 'Proponer una traducción del concepto',
    h_def: 'Definición operativa',
    chips: ['Elemento', 'Tótem', 'Frecuencia'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_379],
    def_short: 'Propagation transductive du sens.',
    def_long:
      'La genèse d’une matrice de reliance.\n\n' +
      'La ' + CANON.title + ' se despliega como una arquitectura viva de estructuración del ser, fundada en una dinámica vibratoria, sensible, relacional y simbólicamente informada. Hace aparecer, a través de los flujos de lo real, las tramas vibrátiles que vinculan formas, intenciones, percepciones, lenguajes y vivencias en una RéZonans significante y transmutativa.\n\n' +
      'Esta Mathêsis se actualiza en un proceso extratinrioral, espacio de intercambio donde interioridad y exterioridad entran en resonancia y componen zonas de pasaje. El conocimiento se forma allí por circulación, ajuste y reprise. En una lógica synchrêtique, la MOPo opera por adición dinámica de saberes, formas, tradiciones y frecuencias en co-presencia fecunda. Posœnnoïa constituye su fuente pulsativa.\n\n' +
      'La MOPo establece una articulación transductiva entre idea, percibido, dicho y transmitido. Estructura las condiciones de legibilidad y aprendizaje, compromete la naturaleza misma de lo real, y se experimenta dentro de un sistema atravesado por vínculo, ritmo y umbral.',
    h_features: 'Despliegue',
    h_questions: 'Pruebas de uso',
    hint_fold: 'desplegar',
    example_title: 'Ejemplo operativo',
    example: '1) Cuando líneas de sentido se cruzan y exigen sostén: « la MOPo ancla ». 2) Cuando el sentido circula entre idea, percibido, dicho y transmitido: « la MOPo propaga ». 3) Cuando una singularidad debe acordarse al campo sin perder su firma: « j’active la MOPo ».',
    features: [
      '« Genèse d’une matrice de reliance »: la MOPo vuelve practicable la circulación transductiva del sentido y ajusta las singularidades.',
      'Arquitectura viva de estructuración del ser por RéZonans: formas, intenciones, percepciones, lenguajes y vivencias se componen en campo activo.',
      'Proceso extratinrioral: espacio de pasaje donde interioridad y exterioridad entran en resonancia y forman zonas de intercambio.',
      'Lógica synchrêtique: adición dinámica de saberes, formas, tradiciones y frecuencias en co-presencia fecunda.',
      'Función principal: propagation transductive du sens; sostén vibratorio para las líneas de sentido cruzadas; anclaje para el ajuste del sentido.'
    ],
    questions: [
      'Cuando líneas de sentido se cruzan y exigen sostén: « la MOPo ancla ».',
      'Cuando el sentido circula entre idea, percibido, dicho y transmitido: « la MOPo propaga ».',
      'Cuando una singularidad debe acordarse al campo sin perder su firma: « j’active la MOPo ».',
      'Cuando las singularidades deben armonizarse en un campo vivo de percepción, creación y transmisión: « la MOPo relie ».'
    ],
    h_family: 'Posición y relaciones',
    family_1: '<p><strong>Posición sistémica:</strong> la MOPo pertenece a <strong>Katûsýs</strong>, en el corazón de la banda interna de frecuencias potenciales procedente de <strong>La Katûvýs</strong>. Se encarna en los <strong>Piliers</strong>, <strong>Outils</strong> y <strong>Engrenages</strong>, se activa por las <strong>Modalités opératives</strong>, y se experimenta en topologías y prácticas como <strong>Posœnnomia</strong> y <strong>Posœnnoïamie</strong>.</p>',
    family_2: '<p><strong>Relaciones prioritarias:</strong> la MOPo entra en sintonia con <strong>Lulæṣírasen</strong>, <strong>Tiqqunbahu</strong>, <strong>Takimarah</strong>, <strong>Extratinrieur</strong>, <strong>Katûvýsissence</strong> y <strong>Ušôprogalenmestûd</strong>. Actúa como estructura transductiva de propagación del sentido en todo <strong>Katûsýs</strong>.</p>',
    h_wordbuild: 'Construcción del nombre y frecuencia 379',
    word_blocks: [
      { head: 'Mathêsis', text: 'Estructura las condiciones de legibilidad y aprendizaje de lo real; potencia de estructuración del sentido.' },
      { head: 'Ontologique', text: 'Compromete la naturaleza misma de lo real: ser, relación, umbral, circulación, modulación.' },
      { head: 'Posœnnoïale', text: 'Califica el modo de experiencia y activación propio del sistema: RéZonans, pasaje, ritmo, inteligencia vibratoria.' },
      { head: 'Sigla canonizada', text: 'MOPo es una sigla canonizada: signo breve para un órgano de estructuración viva, movilizable de inmediato en la práctica.' },
      { head: 'Frecuencia 379', text: '379 actúa como frecuencia-umbral de estructuración dinámica: 3 vincula, 7 abre un pasaje interior, 9 prolonga hacia la transmisión y la expansión espiral. La reducción 3 + 7 + 9 = 19 → 10 → 1 señala el retorno espiral a Posœnnoïa.' }
    ],
    word_notes: [
      'Élément: La Katûvýs; Totem: Êkhö; Frecuencia (nombre-guide): 379.',
      'Ossature transductive du sens; matrice de reliance.',
      'La MOPo organiza las interacciones entre percepción, lenguaje, creación e intención para volver legible la dinámica de lo real.'
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || 'fr';
    if (l === 'en') return FALLBACK_EN;
    if (l === 'es') return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{ return node.getAttribute('data-po-lex-id') || ''; }catch(e){ return ''; }
  }

  function lockNode(el){
    if (!el || !el.setAttribute) return;
    try{ el.setAttribute('translate', 'no'); }catch(e){}
    try{ if (el.classList){ el.classList.add('notranslate'); el.classList.add('po-lex-slotlock'); } }catch(e){}
  }

  function normalizeCanonicalFrench(text){
    var s = clampStr(text);
    if (!s) return s;
    s = s.replace(/\bPosœnnoïal Ontological Mathesis \(MOPo\)\b/g, CANON.title);
    s = s.replace(/\bMathesis ontológica posœnnoïal \(MOPo\)\b/g, CANON.title);
    s = s.replace(/\bguide-number\b/gi, 'nombre-guide');
    s = s.replace(/\bn[uú]mero-gu[ií]a\b/gi, 'nombre-guide');
    return s;
  }

  function firstNonEmpty(){
    for (var i=0;i<arguments.length;i++){
      var v = arguments[i];
      if (Array.isArray(v)){
        if (v.length) return v;
      } else if (clampStr(v)) return v;
    }
    return Array.isArray(arguments[0]) ? [] : '';
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || 'fr';
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];
    var lexId = getAxisLexId(node);
    var entry = lexId ? getLexiconEntry(lexId) : null;

    out.title = CANON.title;

    if (entry){
      var frTerm = firstNonEmpty(pickTerm(entry, 'fr'), CANON.title);
      out.title = frTerm;
      if (l === 'fr'){
        out.def_short = firstNonEmpty(pickDefShort(entry, 'fr'), out.def_short);
        out.def_long = firstNonEmpty(pickDefLong(entry, 'fr'), out.def_long);
        var fFR = firstNonEmpty(pickArray(entry, 'fr', 'features'), pickArray(entry, 'fr', 'characteristics'), out.features);
        var qFR = firstNonEmpty(pickArray(entry, 'fr', 'questions'), pickArray(entry, 'fr', 'usage_questions'), out.questions);
        out.features = fFR;
        out.questions = qFR;
      }
    }

    out.title = CANON.title;
    out.title_img = base.title_img || IMG_IDEOGRAM_CONCEPT;
    out.chip_urls = base.chip_urls || [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_379];
    out.def_short = normalizeCanonicalFrench(out.def_short);
    out.def_long = normalizeCanonicalFrench(out.def_long);
    return out;
  }

  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.textContent = normalizeCanonicalFrench(clampStr(txt));
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.innerHTML = protectKeywordsHTML(normalizeCanonicalFrench(clampStr(html)));
    protectKeywordsInElement(el);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var s = clampStr(src), a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute('src'); }catch(e){}
      try{ el.setAttribute('alt', ''); }catch(e){}
      try{ el.style.visibility = 'hidden'; }catch(e){}
      return;
    }
    try{ el.setAttribute('src', s); }catch(e){}
    try{ el.setAttribute('alt', a); }catch(e){}
    try{ el.style.visibility = ''; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){ setSlotImg(root, slot, src, alt); }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push('<li>' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(arr[i]))) + '</li>');
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var t = normalizeCanonicalFrench(clampStr(exampleTitle));
    var x = normalizeCanonicalFrench(clampStr(exampleText));
    if (!t && !x){ el.innerHTML = ''; return; }
    el.innerHTML = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + '</div>';
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.head))) + '</div><div class="po-axis-wb__t">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.text))) + '</div></div>');
    }
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function applyToAxis(node, lang){
    var data = getAxisData(node, lang);
    var chipUrls = Array.isArray(data.chip_urls) ? data.chip_urls : [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_379];
    setSlotImgSrc(node, 'title_img', data.title_img || IMG_IDEOGRAM_CONCEPT, data.title || CANON.title);
    setSlotText(node, 'title', data.title || CANON.title);
    setSlotHTML(node, 'kicker', data.kicker || '');
    setSlotText(node, 'h_def', data.h_def || '');

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, 'chip_1', chips[0] || '');
    setSlotText(node, 'chip_2', chips[1] || '');
    setSlotText(node, 'chip_3', chips[2] || '');
    setSlotImgSrc(node, 'chip_1_img', chipUrls[0] || IMG_ELEMENT, chips[0] || '');
    setSlotImgSrc(node, 'chip_2_img', chipUrls[1] || IMG_TOTEM, chips[1] || '');
    setSlotImgSrc(node, 'chip_3_img', chipUrls[2] || IMG_FREQ_379, chips[2] || '');

    setSlotHTML(node, 'def_short', htmlParagraphize(data.def_short || ''));
    setSlotHTML(node, 'def_long', htmlParagraphize(data.def_long || ''));

    setSlotText(node, 'h_features', data.h_features || '');
    setSlotText(node, 'hint_fold', data.hint_fold || '');
    renderList(node, 'features', data.features || []);

    setSlotText(node, 'h_questions', data.h_questions || '');
    setSlotText(node, 'hint_fold2', data.hint_fold || '');
    renderList(node, 'questions', data.questions || []);
    renderExampleBox(node, 'example_box', data.example_title || '', data.example || '');

    setSlotText(node, 'h_family', data.h_family || '');
    setSlotText(node, 'hint_fold3', data.hint_fold || '');
    setSlotHTML(node, 'family_1', data.family_1 || '');
    setSlotHTML(node, 'family_2', data.family_2 || '');

    setSlotText(node, 'h_wordbuild', data.h_wordbuild || '');
    renderWordBlocks(node, 'wordbuild_blocks', data.word_blocks || []);
    renderList(node, 'wordbuild_notes', data.word_notes || []);

    setSlotText(node, 'cta_translate', data.cta_translate || '');
  }

  function applyLangEverywhere(lang){
    var l = normLang(lang) || getLang() || 'fr';
    storeLang(l);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) applyToAxis(roots[i], l);
    initAudioEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function init(){
    var existing = readStoredLang();
    if (!existing) storeLang(detectBrowserLang());
    applyLangEverywhere(getLang());
    if (!window.__PO_K5_MOPO_LEX_READY_BOUND__){
      window.__PO_K5_MOPO_LEX_READY_BOUND__ = true;
      window.addEventListener('po:lexicon-ready', function(){
        __PO_PROTECT_CACHE__.key = '';
        __PO_PROTECT_CACHE__.re = null;
        applyLangEverywhere(getLang());
      });
    }
    try{
      var mo = new MutationObserver(function(muts){
        if (__PO_HTML_LANG_SYNC__) return;
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === 'attributes' && muts[i].attributeName === 'lang'){
            var htmlLang = normLang(document.documentElement.getAttribute('lang') || '') || '';
            var storedLang = readStoredLang() || '';
            if (htmlLang && htmlLang !== storedLang){
              try{ localStorage.setItem(STORAGE_KEY, htmlLang); }catch(e){}
              try{ localStorage.setItem(STORAGE_KEY_COMPAT, htmlLang); }catch(e){}
              applyLangEverywhere(htmlLang);
            }
            break;
          }
        }
      });
      if (document && document.documentElement) mo.observe(document.documentElement, { attributes:true });
    }catch(e){}
    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_CACHE__.key = '';
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5MOPoTextsFR_EN_ES_20260303 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || 'fr';
      return applyLangEverywhere(l);
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){ return window.PoKatupirsia5MOPoTextsFR_EN_ES_20260303.setLang(lang); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
